import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';

// Ported 1:1 from the prototype `.chip` (removable token) + `.addchip` (dashed add button).
export const styles = {
  chip: {
    k1xSpc: "x3nfvp2",
    kGNEyG: "x6s0dn4",
    kOIVth: "x17d4w8g",
    kZKoxP: "x1gnnpzl",
    kmVPX3: "x1q95rac",
    kaIpWk: "x1d0dq8e",
    kWkggS: "xvys5x3",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kMwMTN: "x1oezkus",
    kMv6JI: "xdv2sak",
    kGuDYH: "x1ct8sxb",
    k63SB2: "xomqrzn",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  chipStatic: {
    kpe85a: "xnuq7ks",
    $$css: true
  },
  remove: {
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    kzqmXN: "x1xp8n7a",
    kZKoxP: "xmix8c7",
    kaIpWk: "x1sxf85j",
    ksu8eU: "xng3xce",
    kWkggS: "xjbqb8w",
    kMwMTN: "xdxw5r1",
    kkrTdU: "x1ypdohk",
    kmkexE: "x1k3q35m",
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x2ssjo2",
    kGzVvX: "xij4iok",
    kDPRdz: "x1tqbdv0",
    $$css: true
  },
  addchip: {
    k1xSpc: "x3nfvp2",
    kGNEyG: "x6s0dn4",
    kOIVth: "x17d4w8g",
    kZKoxP: "x1gnnpzl",
    kmVPX3: "x84vhe8",
    kaIpWk: "x1d0dq8e",
    kMzoRj: "xmkeg23",
    ksu8eU: "xbsl7fq",
    kVAM5u: "xaj8nyx",
    kWkggS: "xjbqb8w",
    kMwMTN: "xdxw5r1",
    kMv6JI: "xdv2sak",
    kGuDYH: "x1ct8sxb",
    k63SB2: "xomqrzn",
    kkrTdU: "x1ypdohk",
    kmkexE: "x1k3q35m",
    kI3sdo: "x1a2a7pz xx4dj4q",
    kaVNsj: "xbrc2jj",
    kDPRdz: "xewcj4l",
    $$css: true
  }
};